__turbopack_context__.v({
  "buttonContainer": "DefaultFallback-module-scss-module__f0kZDq__buttonContainer",
  "description": "DefaultFallback-module-scss-module__f0kZDq__description",
  "errorDetails": "DefaultFallback-module-scss-module__f0kZDq__errorDetails",
  "errorDetailsSummary": "DefaultFallback-module-scss-module__f0kZDq__errorDetailsSummary",
  "errorStack": "DefaultFallback-module-scss-module__f0kZDq__errorStack",
  "retryButton": "DefaultFallback-module-scss-module__f0kZDq__retryButton",
  "root": "DefaultFallback-module-scss-module__f0kZDq__root",
  "title": "DefaultFallback-module-scss-module__f0kZDq__title",
});
